export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8981.9107d9e6.jpg";